const required = value =>
  value || typeof value === 'number'
    ? true
    : 'Fältet måste fyllas i';

export default required;